import React from "react"
import NavBar from "./NavBar"


const Header = ( { children })=>{

  return (<header>
 
  { children }
  </header>);

}


export default Header;